import React, {
  createContext,
  Dispatch,
  SetStateAction,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { Box, Container, Grid2, Stack } from "@mui/material";
import Header from "./header";
import Left from "./left";
import Right from "./right";
import { useDispatch, useSelector } from "react-redux";
import { useBackdropContext } from "../../contexts/backdrop/BackdropProvider";
import { asyncSearchList } from "../../utils/httpRequests";
import { useAlertContext } from "../../contexts/alert/AlertProvider";
import { isArray } from "lodash";
import { updateCurrentHd } from "../../redux/reducers/kitchen.reducer";

type KitchenContextType = {
  hds: any[];
  chebiens: any[];
  setLoad: Dispatch<SetStateAction<number>>;
  setHds: Dispatch<SetStateAction<any[]>>;
};
const KitchenContext = createContext<KitchenContextType>({
  hds: [],
  chebiens: [],
  setLoad: () => {},
  setHds: () => {},
});

const heigths = {
  header: "50px",
};

function KitchenPage() {
  const { currentHd, currentStore } = useSelector(
    (state: any) => state.kitchen
  );
  const token = useSelector((state: any) => state.auth.token);
  const app = useSelector((state: any) => state.app.data);
  const { setOpenBackdrop } = useBackdropContext();
  const { showAlert } = useAlertContext();
  const [hds, setHds] = useState<any[]>([]);
  const [load, setLoad] = useState<number>(0);
  const dispatch = useDispatch();

  const getHds = async () => {
    setOpenBackdrop?.(true);
    const resp = await asyncSearchList({
      apiCode: "pbl_nh",
      token,
      idApp: app?._id,
      condition: {
        page: 1,
        limit: 999999,
        q: { ma_kho: currentStore?.ma_kho, trang_thai: "1" },
      },
    });
    if (resp?.status !== 200) {
      showAlert({
        type: "error",
        message:
          resp?.data?.error ||
          resp?.data?.message ||
          "Lỗi khi tải thông tin đơn hàng",
      });
    }
    setHds(resp?.data || []);
    setOpenBackdrop?.(false);
  };

  const initHd = () => {
    dispatch(updateCurrentHd(hds[0]));
  };

  const chebiens = useMemo(() => {
    return (currentHd?.details || []).filter(
      (item: any) => item.sl_xuat < item.sl_order
    );
  }, [currentHd]);

  useEffect(() => {
    if (!currentStore) {
      const displayStore = document.getElementById("display-store");
      displayStore?.click();
    } else {
      getHds();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentStore, load]);

  useEffect(() => {
    if (isArray(hds) && hds.length > 0) {
      initHd();
    } else {
      dispatch(updateCurrentHd(null));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hds]);

  return (
    <KitchenContext.Provider value={{ hds, chebiens, setLoad, setHds }}>
      <Stack
        sx={{
          width: "100%",
          minHeight: "100vh",
          backgroundColor: "background.default",
        }}
      >
        <Header height={heigths.header} />
        <Container>
          <Box
            sx={{ width: "100%", height: `calc(100vh - ${heigths.header})` }}
          >
            <Grid2 container spacing={2} sx={{ height: "100%" }}>
              <Grid2 size={{ xs: 12, md: 4 }}>
                <Left />
              </Grid2>
              <Grid2 size={{ xs: 12, md: 8 }}>
                <Right />
              </Grid2>
            </Grid2>
          </Box>
        </Container>
      </Stack>
    </KitchenContext.Provider>
  );
}

export default KitchenPage;

export const useKitchenContext = () => {
  const value = useContext(KitchenContext);
  if (!value) {
    throw new Error("Kitchen context must be used inside kitchen provider");
  }
  return value;
};
